import { Link } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, CardContent, Button } from '../../../components/ui';
import { cn } from '../../../lib/cn';

const STATUS_STYLES = {
  draft: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
  published: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
};

function MapSetCard({ m, t }) {
  return (
    <Card className="flex flex-col hover:shadow-md transition-shadow">
      <CardContent className="flex-1 p-5">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white line-clamp-2 leading-snug">
            {m.name}
          </h3>
          {!m.is_own && (
            <span className="flex-shrink-0 text-xs text-gray-400 dark:text-gray-500 mt-0.5">{t('teacherAtlasMapSets.shared')}</span>
          )}
        </div>

        <span className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mb-2', STATUS_STYLES[m.status] || STATUS_STYLES.draft)}>
          {m.status}
        </span>

        {m.description && (
          <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-2 mb-3">
            {m.description}
          </p>
        )}

        <Link href={`/teacher/atlas_map_sets/${m.id}`}>
          <Button variant="secondary" size="sm">{t('teacherAtlasMapSets.viewMapSet')}</Button>
        </Link>
      </CardContent>
    </Card>
  );
}

export default function AtlasMapSetsIndex({ map_sets = [] }) {
  const { t } = useTranslation();

  return (
    <TeacherShell scrollTitle={t('teacherAtlasMapSets.title')}>
      <TeacherPageHeader
        title={t('teacherAtlasMapSets.title')}
        subtitle={t('teacherAtlasMapSets.subtitle')}
        actions={
          <Link href="/teacher/atlas_map_sets/new">
            <Button variant="primary">{t('teacherAtlasMapSets.newMapSet')}</Button>
          </Link>
        }
      />

      {map_sets.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-gray-500 dark:text-gray-400 mb-4">
            {t('teacherAtlasMapSets.noMapSets')}
          </p>
          <Link href="/teacher/atlas_map_sets/new">
            <Button variant="primary">{t('teacherAtlasMapSets.createFirstMapSet')}</Button>
          </Link>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {map_sets.map((m) => (
            <MapSetCard key={m.id} m={m} t={t} />
          ))}
        </div>
      )}
    </TeacherShell>
  );
}
